import { render, staticRenderFns } from "./BigFavorites.vue?vue&type=template&id=1b163ca0&scoped=true&"
import script from "./BigFavorites.vue?vue&type=script&lang=js&"
export * from "./BigFavorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b163ca0",
  null
  
)

export default component.exports